import React, { CSSProperties, FC } from 'react';

interface ImageProps {
  src?: string;
  alt?: string;
  responsive?: boolean;
  height?: string;
  width?: string;
  className?: string;
  style?: CSSProperties;
}

const Image: FC<ImageProps> = ({
  src,
  alt = '',
  responsive = false,
  height,
  width,
  className = '',
  style = {},
}) => {
  // Base styles
  const baseStyles: CSSProperties = {
    display: 'block',
    maxWidth: '100%',
    ...style,
  };

  // Apply responsive styles if needed
  if (responsive) {
    baseStyles.height = 'auto';
    baseStyles.maxWidth = '100%';
  }

  // Apply explicit height/width if provided
  if (height) {
    baseStyles.height = height;
  }

  if (width) {
    baseStyles.width = width;
  }

  return <img src={src} alt={alt} className={className} style={baseStyles} />;
};

export default Image;
